document.addEventListener('click', function (event) {
  const productsLink = event.target.closest('[data-products-link]');
  if (!productsLink) return;
  event.preventDefault();
  window.location.assign(productsLink.href);
});

document.addEventListener('click', function (event) {
  const minus = event.target.closest('[data-minus]');
  const plus = event.target.closest('[data-plus]');
  if (!minus && !plus) return;
  const quantity = event.target.closest('.quantity');
  if (!quantity) return;
  const input = quantity.querySelector('input');
  const value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
  input.value = value;
});

document.addEventListener('submit', async function (event) {
  const form = event.target;
  const addButton = event.submitter;
  if (!form.matches('form[action*="/cart/add"]') || !addButton || addButton.name !== 'add') return;

  event.preventDefault();
  const originalLabel = addButton.textContent;
  addButton.disabled = true;
  addButton.textContent = 'Adding...';

  try {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add this item.');

    const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Unable to refresh the bag.');
    const cart = await cartResponse.json();
    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.hidden = cart.item_count === 0;
    }
    addButton.textContent = 'Add to bag';
    if (addButton.hasAttribute('data-open-cart-after-add')) await novaOpenCart();
    window.setTimeout(function () {
      addButton.textContent = originalLabel;
    }, 1600);
  } catch (error) {
    addButton.textContent = 'Please try again';
    window.setTimeout(function () {
      addButton.textContent = originalLabel;
    }, 2000);
  } finally {
    addButton.disabled = false;
  }
});

function novaMoney(cents) {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format((cents || 0) / 100);
}

function novaEscape(value) {
  const element = document.createElement('div');
  element.textContent = value || '';
  return element.innerHTML;
}

function novaUpdateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (element) {
    element.textContent = count;
    element.hidden = count === 0;
  });
  const drawerCount = document.querySelector('[data-drawer-count]');
  if (drawerCount) drawerCount.textContent = count;
}

function novaRenderCart(cart) {
  const itemsContainer = document.querySelector('[data-cart-items]');
  const footer = document.querySelector('[data-cart-footer]');
  const total = document.querySelector('[data-cart-total]');
  if (!itemsContainer || !footer || !total) return;

  novaUpdateCartCount(cart.item_count);
  total.textContent = novaMoney(cart.total_price);
  footer.hidden = cart.item_count === 0;

  if (cart.item_count === 0) {
    itemsContainer.innerHTML = '<p class="nova-cart-empty">Your shopping bag is empty.</p>';
    return;
  }

  itemsContainer.innerHTML = cart.items.map(function (item, index) {
    const image = item.image ? '<img src="' + novaEscape(item.image) + '" alt="' + novaEscape(item.product_title) + '">' : '<span></span>';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + novaEscape(item.variant_title) + '</small>' : '';
    return '<article class="nova-cart-drawer__item">' + image +
      '<div><h3>' + novaEscape(item.product_title) + '</h3>' + variant +
      '<div class="nova-cart-quantity"><button type="button" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="nova-cart-remove" data-cart-line="' + (index + 1) + '" data-cart-quantity="0">Remove</button></div>' +
      '<strong class="nova-cart-drawer__price">' + novaMoney(item.final_line_price) + '</strong></article>';
  }).join('');
}

async function novaFetchCart() {
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to load cart.');
  const cart = await response.json();
  novaRenderCart(cart);
  return cart;
}

async function novaOpenCart() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;
  overlay.hidden = false;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('nova-cart-open');
  try { await novaFetchCart(); } catch (error) {
    const items = document.querySelector('[data-cart-items]');
    if (items) items.innerHTML = '<p class="nova-cart-empty">Unable to load your bag. Please try again.</p>';
  }
}

function novaCloseCart() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('nova-cart-open');
  window.setTimeout(function () { overlay.hidden = true; }, 280);
}

document.addEventListener('click', async function (event) {
  if (event.target.closest('[data-cart-toggle]')) {
    event.preventDefault();
    await novaOpenCart();
    return;
  }
  if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
    novaCloseCart();
    return;
  }
  const quantityButton = event.target.closest('[data-cart-line][data-cart-quantity]');
  if (!quantityButton) return;
  quantityButton.disabled = true;
  try {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const response = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(quantityButton.dataset.cartLine), quantity: Number(quantityButton.dataset.cartQuantity) })
    });
    if (!response.ok) throw new Error('Unable to update cart.');
    novaRenderCart(await response.json());
  } finally {
    quantityButton.disabled = false;
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') novaCloseCart();
});

document.addEventListener('DOMContentLoaded', function () {
  if (new URLSearchParams(window.location.search).get('nova_products') === 'all') {
    const productsTemplate = document.querySelector('#NovaProductsPageTemplate');
    const productsMain = document.querySelector('#MainContent');
    if (productsTemplate && productsMain) {
      productsMain.replaceChildren(productsTemplate.content.cloneNode(true));
      document.title = 'Products – NOVA';
      window.scrollTo(0, 0);
      return;
    }
  }
  if (new URLSearchParams(window.location.search).get('nova_product') !== 'featured-product') return;
  const template = document.querySelector('#NovaFallbackProductTemplate');
  const main = document.querySelector('#MainContent');
  if (!template || !main) return;
  main.replaceChildren(template.content.cloneNode(true));
  document.title = 'Insulated Travel Cup | Everyday Edition – NOVA';
  window.scrollTo(0, 0);
});
